import { Providers } from './providers';

export function App() {
  return <Providers>aaa</Providers>;
}
